import { useLocation } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { DeviceOptimizationModal } from "../components";
import { useTeamMemberIsAuth } from "../hooks";
import { AuthenticatedRouter } from "./AuthenticatedRouter";
import { GuestRouter } from "./GuestRouter";

export const Router = () => {
  const location = useLocation();
  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  const { data: isLoggedIn, isFetching } = useTeamMemberIsAuth();

  if (isFetching) {
    return <LoadingState className="h-screen-calculated" />;
  }

  if (!isLoggedIn) {
    return <GuestRouter />;
  }

  if (isLoggedIn) {
    return (
      <>
        <DeviceOptimizationModal />
        <AuthenticatedRouter previousLocation={previousLocation} />
      </>
    );
  }
};
